import { create } from 'zustand'

type UseMainLayoutStoreType = {
  isMobile: boolean
  isTablet: boolean
  isShowFooter: boolean
  sidebarHeight: number
  setLayoutState: (payload: { isMobile: boolean; isTablet: boolean }) => void
  setSidebarHeight: (height: number) => void
  showFooter: () => void
  hideFooter: () => void
}

export const useMainLayoutStore = create<UseMainLayoutStoreType>((set) => {
  const isTablet = false
  const isMobile = false

  return {
    isMobile,
    isTablet,
    sidebarHeight: 0,
    isShowFooter: true,
    setLayoutState(payload) {
      set({ ...payload })
    },
    setSidebarHeight(height) {
      set({ sidebarHeight: height })
    },
    showFooter() {
      set({ isShowFooter: true })
    },
    hideFooter() {
      set({ isShowFooter: false })
    },
  }
})
